import { checkIsNotNullish } from "@tsp-core/utils/nullish";
import { parseUnknownToString } from "@tsp-core/utils/string";

import { AccrualModelUnitName } from "../enums";
import { AccrualModelId, AccrualModelsDictionaryRecord } from "../types";

export function parseAccrualModelId<Input extends unknown>(
  input: Input,
): Input extends AccrualModelId ? AccrualModelId : AccrualModelId | null {
  const id = parseUnknownToString(input);
  if (checkIsNotNullish(id)) {
    return id as AccrualModelId;
  }

  return null as any;
}

export function parseAccrualModelUnitName<Input extends unknown>(
  input: Input,
): Input extends AccrualModelUnitName ? AccrualModelUnitName : AccrualModelUnitName | null {
  const id = parseUnknownToString(input);
  if (checkIsNotNullish(id)) {
    return id as AccrualModelUnitName;
  }

  return null as any;
}

export function checkAccrualModelIsActive(record: AccrualModelsDictionaryRecord): boolean {
  return !record.isDisabled && !record.isDeprecated;
}

export function checkIs1MinuteAccrualModel(unitName: AccrualModelUnitName, quantityDivider: number) {
  return unitName === AccrualModelUnitName.SECOND && quantityDivider === 60;
}

export function formatAccrualModel(unitName: AccrualModelUnitName, quantityDivider: number): string {
  if (checkIs1MinuteAccrualModel(unitName, quantityDivider)) {
    return "1 minute";
  }

  return `${quantityDivider} ${unitName}`.toLowerCase();
}
